import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Text,
  Heading,
  Image,
  Tag,
  HStack,
  VStack,
} from '@chakra-ui/react';
import { Helmet } from 'react-helmet';
import api from 'api/axiosConfig';
import API_BASE from "configs/hostConfig";
import { getImageUrl } from 'utils/ImageImporter';

function BlogPage() {
  const { slug } = useParams();

  const [blogData, setBlogData] = useState({});

  const { title, content, updatedTime, tags, imageUrl } = blogData;

  useEffect(() => {
    api
      .get(`${API_BASE}/api/blog/find-by-slug?slug=${slug}`)
      .then((res) => {
        // console.log('============= fetch blog by slug details response: ', res);
        if (res.status == 200) {
          setBlogData(res.data);
        }
      })
      .catch(() =>
        console.log('failed to fetch blog details data, slug: ', slug)
      );
  }, [slug]);

  return (
    <>
      <Helmet>
        <title>{`${title} | Dynivy`}</title>
        <meta name="title" content={`${title} - Our Blogs`} />
        <meta name="description" content="Abstract of the blog" />
      </Helmet>
      <Box
        maxW="800px"
        mx="auto"
        mt={20}
        mb={8}
        p={6}
        borderWidth="1px"
        borderRadius="lg"
        boxShadow="md"
      >
        <VStack align="start" spacing={4}>
          {/* Blog Title */}
          <Heading as="h1" size="lg">
            {title}
          </Heading>

          {/* Date */}
          <Text fontSize="sm" color="gray.600">
            {new Date(updatedTime).toLocaleDateString()}
          </Text>

          {/* Image */}

          <Image
            src={getImageUrl(imageUrl || '')}
            alt="Blog Image"
            borderRadius="lg"
            objectFit="cover"
            width="100%"
          />

          {/* Blog Content */}
          <Box
            fontSize="lg"
            lineHeight="tall"
            whiteSpace="pre-wrap"
            dangerouslySetInnerHTML={{ __html: content }}
          />

          {/* Tags */}
          {tags && tags.length > 0 && (
            <HStack spacing={2} mt={4}>
              {tags.map((tag, index) => (
                <Tag key={index} colorScheme="blue">
                  {tag}
                </Tag>
              ))}
            </HStack>
          )}
        </VStack>
      </Box>
    </>
  );
}

export default BlogPage;
